import { render, staticRenderFns } from "./groupof.vue?vue&type=template&id=24763939&scoped=true&"
import script from "./groupof.vue?vue&type=script&lang=js&"
export * from "./groupof.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24763939",
  null
  
)

export default component.exports